import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LocationAllowedOsUpdateState } from './location-allowed-os-updates.state';
import * as fromLocationAllowedOsUpdates from './location-allowed-os-updates.reducer';
import { LocationAllowedOsUpdateFeatureKey } from './location-allowed-os-updates.reducer';
import type { LocationAllowedOsUpdate } from '@rocksoft/shared';
import { LocationsRouterStoreSelectors } from '../router';
import { Location } from '@era/locations-sdk';

export const selectLocationAllowedOsUpdateState = createFeatureSelector<LocationAllowedOsUpdateState>(
  LocationAllowedOsUpdateFeatureKey
);

export const selectLocationAllowedOsUpdates = createSelector(
  selectLocationAllowedOsUpdateState,
  fromLocationAllowedOsUpdates.selectLocationAllowedOsUpdates
);

export const selectLocationAllowedOsUpdatesIds = createSelector(
  selectLocationAllowedOsUpdateState,
  fromLocationAllowedOsUpdates.selectLocationAllowedOsUpdateIds
);

export const selectLocationAllowedOsUpdatesEntities = createSelector(
  selectLocationAllowedOsUpdateState,
  fromLocationAllowedOsUpdates.selectLocationAllowedOsUpdateEntities
);

export const selectLocationAllowedOsUpdatesForLocation = createSelector(
  selectLocationAllowedOsUpdates,
  LocationsRouterStoreSelectors.selectLocation,
  (updates: LocationAllowedOsUpdate[], location: Location) => updates.filter((u) => u.locationId === location.uniqueId)
);
